import { Typography } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

const FooterTitle = ({ text }) => (
  <Typography
    sx={{
      fontWeight: '700',
      textTransform: 'capitalize',
      pb: 1,
      fontSize:'1.10rem'
    }}
  >
    {text}
  </Typography>
);
FooterTitle.propTypes = {
  text: PropTypes.string,
};
export default FooterTitle;
